<template lang="pug">
#layout(:class='className')
  .wrapper.centered(:class="{ 'nav-open' : navOpened }")
    sidebar(:open='navOpened')
    .main-panel(:class="{ 'loading' : loading }")
      navigation(@toggleSideBar='toggleSideBar')
      .content
        .container.container-fluid
          .col-md-12
            slot
      md-footer
      .close-layer(v-if='navOpened', @click='onCloseLayerClick')
</template>

<script>

import MainLayout from './main'

export default {
  extends: MainLayout,
  computed: {
    className: function () {
      return 'layout-docs'
    }
  }
}

</script>



// WEBPACK FOOTER //
// docs.vue?66c2b2aa